<script setup lang="ts">
  import { computed, onMounted } from 'vue';

  import { usePermittedMembers } from '@/entities/User';
  import { formatCollaboratorNameAndRegistration } from '@/shared/lib';

  import NotificationFilterModalBase from './NotificationFilterModalBase.vue';
  import { NotificationFilterFormData } from '../model';
  import { STATUS_OPTIONS } from '../model/filter.constants';

  defineProps<{
    currentFilters?: Partial<NotificationFilterFormData>;
  }>();

  const emit = defineEmits<{
    (e: 'close'): void;
    (e: 'update:filter', filters: Partial<NotificationFilterFormData>): void;
    (e: 'clear-filters'): void;
  }>();

  const { userOptions, isLoading, error, fetchUsers } = usePermittedMembers();

  const usersList = computed(() =>
    userOptions.value.map((user) => ({
      id: user.id,
      name: formatCollaboratorNameAndRegistration(user.name, user.registrationNumber, {
        labelWhenNameMissing: 'Nome não disponível',
      }),
    }))
  );

  onMounted(() => {
    fetchUsers();
  });
</script>

<template>
  <NotificationFilterModalBase
    :current-filters="currentFilters"
    :default-custom-periodicity="null"
    :status-options="STATUS_OPTIONS"
    :show-created-by="true"
    :users-list="usersList"
    :users-loading="isLoading"
    :users-error="error"
    grid-border-class="border-b border-gray-02"
    date-section-class="py-6"
    :show-date-section-title="false"
    @close="emit('close')"
    @update:filter="emit('update:filter', $event)"
    @clear-filters="emit('clear-filters')"
  />
</template>
